/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import * as styles from "./ProjectSpecifications.module.css";
import { RightOutlined } from "@ant-design/icons";
import dotsIcon from "../../../images/on-going-projects/enchanted/Icons/dots-icon.png";

function ProjectSpecifications() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div
      className={styles.projectSpecificationsContainer}
      id="project-specifications"
    >
      <h1>
        <img loading="lazy"  src={dotsIcon} alt="dots-icon" className={styles.dotsIcon} />
        Project Specifications
      </h1>
      <div className={styles.projectSpecificationsContent}>
        <div className={styles.accordionContainer}>
          {[
            {
              header: "Structure",
              list: ["RCC wall structure using MIVAN aluminium formwork"],
            },
            {
              header: "Floor Finishes",
              list: [
                "Foyer, Living & Dining – Imported marble",
                "Bedrooms – Matt finish vitrified tiles of KAJARIA or equivalent",
                "Kitchen – Matt finish tiles",
                "Toilets – Matt finish tiles",
                "Common Area & Staircase – Indian granite / Matt finish tiles",
                "Utility / Balcony – Matt finish tiles",
              ],
            },
            {
              header: "Wall Tile",
              list: [
                "Toilets – Vitrified tiles of KAJARIA or equivalent up to false ceiling height",
              ],
            },
            {
              header: "Doors",
              list: [
                "Main Door – Engineered door frame with 50mm thick teak wood veneer shutter polished on both sides",
                "Bedroom Door – Engineered door frame with 38mm thick modular door shutter laminated on both sides",
                "Toilet Door – Engineered door frame with 38mm thick laminated on both sides",
              ],
            },
            {
              header: "Windows & Ventilators",
              list: ["UPVC windows / Aluminium"],
            },
            {
              header: "Plumbing & Sanitary Installations",
              list: [
                "CPVC concealed water line",
                "Master Bedroom Toilet – Grohe or equivalent with single lever with shower head & hand shower",
                "Other Bedroom Toilet – Grohe or equivalent with single lever with shower head & hand shower",
                "Sanitary ware –  All sanitary fittings will be of Catalano or equivalent",
                "Shower partition – Fixed glass in master bedroom toilet",
                "Provision for Aquaguard point (kitchen), Geyser for all bathrooms and Chimney provision with core cutting",
                "Provision for Washing Machine, Dishwasher, Dryer in utility area",
                "Power socket for Chimney, Refrigerator, Microwave Oven, Mixer/Grinder"
              ],
            },
            {
              header: "Elevator",
              list: ["Mitsubishi or equivalent"],
            },
            {
              header: "Driveway",
              list: [
                "As per architect's specification/Interlock paver blocks",
              ],
            },
            {
              header: "Security System",
              list: [
                "Video door phones for all apartments",
                "CCTV camera around the driveway, entrance & lift",
              ],
            },
            {
              header: "Power Backup",
              list: [
                "DG backup to power 1 light and 1 fan in the living room, dining area and all bedrooms. 1 refrigerator in the kitchen. Additional backup for the elevator and common area lighting",
              ],
            },
            {
              header: "Electrical",
              list: [
                "Concealed wiring with modular switches (Panasonic or equivalent)",
                "3 Phase electricity supply with MCB and RCCB",
                "Telephone/Data point provision in living and master bedroom conduit provision only from flat to shaft",
                "LED Light fixtures (Philips/Havells/GM/Luminogloz or equivalent)",
              ],
            },
            {
              header: "Painting",
              list: [
                "Internal walls and ceiling: Two coats of putty, one coat primer and two coats of emulsion paint (Dulux or Asian)"
              ],
            },
            {
              header: "Other Facilities & Amenities",
              list: [
                "2-way Intercom facility between all apartments and security room",
                "DTH system provision will be provided",
                "Adequate landscape around the building",
                "Modern fire-fighting equipment as per Fire NOC",
                "Clubhouse: Gymnasium, Yoga Hall and Multipurpose Hall at Podium floor",
                "EV Charger provision at each flat’s car parking (Each 1 point, max 3kW)",
              ],
            },
            {
              header: "Lutron Home Automation System",
              additionalFeatures: [],
              list: [
                "A 4/6-button touch panel in living and dining area (light & fan on/off control)",
                "A handy 4-button touch panel by the bedside",
                "Gas leak Sensor",
                "Bathroom geyser on/off control",
              ],
            },
          ].map((item, index) => (
            <div key={index} className={styles.accordionItem}>
              <div
                className={`${styles.accordionHeader} ${
                  activeIndex === index ? styles.active : ""
                }`}
                onClick={() => toggleAccordion(index)}
              >
                <RightOutlined className={styles.arrow} />
                {item.header}
              </div>
              <ul
                className={`${styles.accordionContent} ${
                  item?.additionalFeatures?.length
                    ? styles.additionalFeatures
                    : ""
                } ${activeIndex === index ? styles.active : ""}`}
              >
                {item?.list?.length
                  ? item?.list?.map((listItem, index) => (
                      <li key={index}>{listItem}</li>
                    ))
                  : ""}
                {item?.additionalFeatures?.length ? (
                  <li>Additional Features:</li>
                ) : (
                  ""
                )}
                {item?.additionalFeatures?.length
                  ? item?.additionalFeatures?.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))
                  : ""}
                {item?.subPoints?.length
                  ? item?.subPoints?.map((subPoint, index) => (
                      <>
                        <li key={index} className={styles.subPointTitle}>
                          {subPoint.title}
                        </li>
                        {subPoint.list?.map((listItem, index) => (
                          <li key={index} className={styles.subPointList}>
                            {listItem}
                          </li>
                        ))}
                      </>
                    ))
                  : ""}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProjectSpecifications;
